import * as dis2 from '../../dispossitions/dispossitions.const';
import {ACTIVITY_TYPE_CMC_EVENTS} from '../activity-type.const';
import {OTHER_FEE} from '../payamnets.const';

export const BOARD_MEETING_LABEL = 'Board Meeting';
export const ANNUAL_METTING_LABEL = 'Annual Meeting';
export const COMMITTEE_MEETING_LABEL = 'Committee Meeting';
export const STATEGIC_PLANNING_LABEL = 'Strategic Planning';
export const EVENTS_LABEL = 'Events';
export const OTHER_LABEL = 'Other';
//
export const ORGANIZATIONAL_EVENTS_ID = '65f062bc2d71dfb4e189120e';
export const BOARD_MEETING_ID = '65f062bc2d71dfb4e188115e';
export const ANNUAL_METTING_ID = '65f062bc2d71dfb4e188116e';
export const COMMITTEE_MEETING_ID = '65f064bc2d71dfb4e188117e';
export const STATEGIC_PLANNING_ID = '65f062bc2d71dfb4e188117e';
export const EVENTS_ID = '65f062bc2d71dfb4e188118e';
export const OTHER_ID = '65f062bc2d71dfb4e188119e';

export const BOARD_MEETING = {
    _id: BOARD_MEETING_ID,
    label: BOARD_MEETING_LABEL,
    defaultDisposition: dis2.OE_BM_OPEN_PENDING,
    dispositions: [dis2.OE_BM_OPEN_PENDING, dis2.OE_BM_COMPLETED, dis2.OE_BM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const ANNUAL_METTING = {
    _id: ANNUAL_METTING_ID,
    label: ANNUAL_METTING_LABEL,
    defaultDisposition: dis2.OE_AM_OPEN_PENDING,
    dispositions: [dis2.OE_AM_OPEN_PENDING, dis2.OE_AM_COMPLETED, dis2.OE_AM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const COMMITTEE_MEETING = {
    _id: COMMITTEE_MEETING_ID,
    label: COMMITTEE_MEETING_LABEL,
    defaultDisposition: dis2.OE_CM_OPEN_PENDING,
    dispositions: [dis2.OE_CM_OPEN_PENDING, dis2.OE_CM_COMPLETED, dis2.OE_CM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const STATEGIC_PLANNING = {
    _id: STATEGIC_PLANNING_ID,
    label: STATEGIC_PLANNING_LABEL,
    defaultDisposition: dis2.OE_SP_OPEN_PENDING,
    dispositions: [dis2.OE_SP_OPEN_PENDING, dis2.OE_SP_COMPLETED, dis2.OE_SP_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const EVENTS = {
    _id: EVENTS_ID,
    label: EVENTS_LABEL,
    defaultDisposition: dis2.OE_EV_OPEN_PENDING,
    dispositions: [dis2.OE_EV_OPEN_PENDING, dis2.OE_EV_COMPLETED, dis2.OE_EV_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const OE_OTHER = {
    _id: OTHER_ID,
    label: OTHER_LABEL,
    defaultDisposition: dis2.OE_OTH_OPEN_PENDING,
    dispositions: [dis2.OE_OTH_OPEN_PENDING, dis2.OE_OTH_COMPLETED, dis2.OE_OTH_OTHER],
    paymentIn: [dis2.OT_OT_OTHER],
    paymentOut: [dis2.OT_OT_OTHER],
};

export const ORGANIZATIONAL_EVENTS = {
    _id: ORGANIZATIONAL_EVENTS_ID,
    icon: 'organizationalEvents',
    label: ACTIVITY_TYPE_CMC_EVENTS,
    description: 'Events organized by the CMC',
    subTypes: [BOARD_MEETING, ANNUAL_METTING, COMMITTEE_MEETING, STATEGIC_PLANNING, EVENTS, OE_OTHER],
};
